import { Divider } from "antd";
import { useState } from "react";
import { Redirect, Route } from "react-router-dom";
import "../Dashboard/dashboard.css";
import PageHeader from "../PageHeader";
import AnalyticsNav from "./AnalyticsNav";
import Cards from "./Cards";
import Expenses from "./Expenses";
import LineGraph from "./LineArea";
import Reports from "./Reports";
import ReportSec from "./ReportsSec";
import Advances from "./AdvancesSec";
import Snapshots from "./Snapshots";
import Trips from "./Trips";
import { hasAccess } from "../../utils";
import { useRef } from "react";

const Summary = ({ showGraph }) => {
  return (
    <>
      <div className="reports">
        {showGraph && (
          <>
            <Divider />
            <div
              className="mt1"
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <LineGraph
                width={1000}
                height={350}
                id={"lineAreaGraph"}
                data={[
                  { day: "Jan", txnValue: 39 },
                  { day: "Feb", txnValue: 49 },
                  { day: "Mar", txnValue: 69 },
                  { day: "Apr", txnValue: 59 },
                ]}
              />
            </div>
          </>
        )}
        <Divider />
        <div className="heading">
          <span>Snapshots</span>
        </div>
        <Divider />
      </div>
      <Snapshots />
    </>
  );
};

const Analytics = () => {
  const [showGraph, setShowGraph] = useState();
  const [filterObj, setFilterObj] = useState({});
  const [filters, setfilters] = useState({});
  const pdfURL = useRef();

  return (
    <>
      <div className="heading-div">
        <PageHeader
          title={`Analytics`}
          navigation={{
            Home:
              hasAccess("dashboard", "read") || hasAccess("dashboard", "write")
                ? "/dashboard"
                : "",
            Analytics: null,
          }}
        />
        <AnalyticsNav />
        <div className="analytics-body">
          <Reports
            setShowGraph={setShowGraph}
            setFilterObj={setFilterObj}
            filters={filterObj}
            apiFilters={filters}
            setFilters={setfilters}
            pdfURL={pdfURL}
          />

          <Route
            exact
            path={"/analytics"}
            render={() => {
              return <Redirect to="/analytics/expenses" />;
            }}
          />

          <Route
            exact
            path={"/analytics/expenses"}
            render={() => (
              <Expenses
                showGraph={showGraph}
                filterObj={filterObj}
                apiFilters={filters}
                setFilterObj={setFilterObj}
                pdfURL={(func) => {
                  pdfURL.current = func;
                }}
              />
            )}
          />
          <Route
            exact
            path={"/analytics/trips"}
            render={() => (
              <Trips
                showGraph={showGraph}
                filterObj={filterObj}
                apiFilters={filters}
                setFilterObj={setFilterObj}
                pdfURL={(func) => {
                  pdfURL.current = func;
                }}
              />
            )}
          />
          <Route
            exact
            path={"/analytics/reports"}
            render={() => (
              <ReportSec
                showGraph={showGraph}
                filterObj={filterObj}
                apiFilters={filters}
                setFilterObj={setFilterObj}
                pdfURL={(func) => {
                  pdfURL.current = func;
                }}
              />
            )}
          />
          <Route
            exact
            path={"/analytics/advances"}
            render={() => (
              <Advances
                showGraph={showGraph}
                filterObj={filterObj}
                apiFilters={filters}
                setFilterObj={setFilterObj}
                pdfURL={(func) => {
                  pdfURL.current = func;
                }}
              />
            )}
          />
          <Route
            exact
            path={"/analytics/cards"}
            render={() => (
              <Cards
                showGraph={showGraph}
                filterObj={filterObj}
                apiFilters={filters}
                setFilterObj={setFilterObj}
                pdfURL={(func) => {
                  pdfURL.current = func;
                }}
              />
            )}
          />
          <Route
            exact
            path={"/analytics"}
            render={() => (
              <Summary
                showGraph={showGraph}
                filterObj={filterObj}
                apiFilters={filters}
              />
            )}
          />
        </div>
      </div>
    </>
  );
};

export default Analytics;
